const debounce = require('lodash/debounce');
const { getTotalHeightBySelector } = require('../common/utils/sizeUtils');
const checkoutStage = require('./checkoutStage');

function calculateCheckoutScrollProperties(stage) {
  // Always substract 2px to avoid having body scroll due to decimal sizes.
  let availableHeight = (document.documentElement.clientHeight || window.innerHeight) - 2; // menos el botón back
  let commonElementsToCheck = 'header.header-no-menu, .checkout-breadcrumbs, .slot-promo-checkout-message:not(.base-slot--hidden), .checkout-error';
  let specificElementsToCheck;

  switch (stage) {
    case checkoutStage.stages.SHIPPING_ADDRESS:
      specificElementsToCheck = '.submit-shipping, .shipment-selector-block .checkout-main__section-title, .shipment-selector-block .selector-block__add-new';
      break;
    case checkoutStage.stages.PLACE_ORDER:
      specificElementsToCheck = '.place-order, .request-invoice-toggler[data-is-invoice-requested="false"]';
      break;
    default:
      break;
  }

  commonElementsToCheck += specificElementsToCheck ? `, ${specificElementsToCheck}` : '';

  const totalElementsHeigh = getTotalHeightBySelector(commonElementsToCheck);
  const checkoutContainerComputedStyles = window.getComputedStyle(document.querySelector('.checkout-container'));
  const containerMarginBottom = parseInt(checkoutContainerComputedStyles.marginBottom, 10);
  const containerMarginTop = parseInt(checkoutContainerComputedStyles.marginTop, 10);

  availableHeight -= (totalElementsHeigh + containerMarginTop + containerMarginBottom);

  document.documentElement.style.setProperty(
    '--checkout-available-list-space',
    `${availableHeight}px`,
  );
}

function checkStageAndScroll() {
  const currentStage = checkoutStage.methods.getStage();
  if (currentStage === checkoutStage.stages.SHIPPING_ADDRESS
    || currentStage === checkoutStage.stages.PLACE_ORDER) {
    handleScrollProperties(currentStage);
  }
}

const handleResize = debounce(() => {
  checkStageAndScroll();
},
500);

function handleScrollProperties(stage) {
  const { FRONT_CONFIG } = window;
  const desktopMedia = window.matchMedia(
    `(min-width: ${FRONT_CONFIG.responsive.bp_1025}px)`,
  );
  const isMobile = !desktopMedia.matches;

  if (isMobile) {
    calculateCheckoutScrollProperties(stage);
  }
}

function calculateCheckoutContentSpace() {
  // This listener won't dissapear
  // eslint-disable-next-line listeners/no-missing-remove-event-listener
  window.addEventListener('resize', handleResize, { passive: true });
}

module.exports = {
  methods: {
    handleScrollProperties,
    checkStageAndScroll,
  },
  init() {
    calculateCheckoutContentSpace();
  },

  keepSessionAlive() {
    const sessionExpiringTimeInMilliseconds = 900000; // 15 mins = 15 * 60 * 1000
    const keepSessionAliveUrl = $('#checkout-main').data('keep-session-alive-url');
    if (keepSessionAliveUrl) {
      setInterval(() => {
        $.ajax({
          url: keepSessionAliveUrl,
          method: 'GET',
          dataType: 'json',
          success: function updateToken(json) {
            $(`[name="${json.csrf.tokenName}"]`).val(json.csrf.token);
          },
        });
      }, sessionExpiringTimeInMilliseconds * 0.9); // Refresh session before expiring
    }
  },
};
